import React from 'react'
import {AuthContext} from '../../lib/AuthContext';
import ParentComponent from '../../lib/ParentComponent';
import { NavLink } from 'react-router-dom';
import ar from '../../locale';
import {title} from '../../constants';

export default class Notfound extends ParentComponent {
    
    static contextType = AuthContext;
    
    constructor(props, context) {
        super(props, context);
        this.state = {
            user: context.user,
        }
    }

    componentDidMount() {
        super.componentDidMount();
        document.title = title + ' - 404';
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    updateState = () => {
        this.setState(prev => {
            return {...prev}
        })
    };

    render() {
        return(
            <div className="error-box">
                <div className="error-body text-center">
                    <h1 className="text-danger">{ar.oops_page_not_found}</h1>
                    <p className="text-muted m-t-30 m-b-30">{ar.not_found_content} <a href="mailto:info@alchemists.com">info@alchemists.com</a></p>
                    <NavLink to="/" className="btn btn-danger btn-rounded waves-effect waves-light m-b-40">{ar.return_to_home}</NavLink>
                </div>
            </div>
        );
    }
};
